module.exports = __webpack_public_path__ + "img/webview.c6f396e2.png";